import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button, Text } from '@components';
import { getAllStorageData } from '@core/storage';
import { FormType, Translation, VariantType } from '@enums';
import { useAppDispatch, useFormLoadingStatus } from '@hooks';
import { fetchFormList, getWorkspaceOptions } from '@store';
import { capitalize, cn } from '@utils';

export const NavigationCategory = ({ categories, isCollapse }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formType = FormType.Cdn;

  const loading = useFormLoadingStatus({ formType });

  const { current_workspace_id: workspace_id } = getAllStorageData();

  const { t: tNavigation } = useTranslation(Translation.Common, { keyPrefix: 'navigator' });

  const handleClick = (navigationName, navigateLink) => {
    if (pathname.includes(navigateLink)) {
      if (!loading) {
        if (navigationName === 'cdn') {
          dispatch(fetchFormList({ formType: FormType.Cdn, params: { workspace_id } }));
        } else if (navigationName === 'workspace') {
          dispatch(getWorkspaceOptions());
        }
      }
    }
    navigate(navigateLink);
  };

  return categories?.map((navigation) => (
    <nav key={navigation?.title} className="flex-col">
      {!isCollapse && !navigation?.subPath?.every((sub) => sub.hidden) && (
        <Text $level={6} $customizeColor className="font-medium text-gray-400">
          {capitalize(navigation?.title)}
        </Text>
      )}
      <ul className={`flex-1 flex flex-col ${isCollapse ? 'gap-y-5' : 'gap-y-2'} pt-3`}>
        {navigation?.subPath?.map((item) => {
          const activeTab = pathname.split('/').slice(0, 2).join('/') === item.href;
          const dynamicButton = cn(
            'text-xs justify-start rounded-xl text-opacity-90 enabled:shadow-none',
            activeTab
              ? 'bg-slate-500/5 text-gray-500'
              : 'transition-all duration-200 ease-linear hover:text-gray-500 text-gray-300',
            isCollapse ? 'w-fit px-2.5 py-2' : 'w-full px-2.5 py-2.5 space-x-3',
          );
          return (
            !item.hidden && (
              <Button
                variant={VariantType.Clean}
                key={item.name}
                hintPlacement="left"
                hint={
                  navigation?.subPath && (
                    <Text $level={5} $customizeColor>
                      {tNavigation(item.name)}
                    </Text>
                  )
                }
                onClick={() => handleClick(item.name, item.href)}
                className={dynamicButton}
                adornment={<item.icon className="size-4 xl:size-5" />}
              >
                {!isCollapse && (
                  <Text $level={5} $customizeColor>
                    {tNavigation(item.name)}
                  </Text>
                )}
              </Button>
            )
          );
        })}
      </ul>
    </nav>
  ));
};
